import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import api from "@/lib/api";
import { Check, X } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) return;
    let count = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired","failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch { setStatus("error"); return; }
      count += 1;
      if (count > 20) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20 text-center">
        {status === "paid" ? (
          <>
            <Check size={64} className="text-[#FF3B30] mx-auto" />
            <h1 data-testid="payment-success" className="font-display font-black text-5xl tracking-tighter mt-6">Payment received.</h1>
            <p className="text-neutral-400 mt-4">Your booking is confirmed. The host has been notified.</p>
            <Link to="/cook" className="btn-signal inline-block mt-8">View bookings</Link>
          </>
        ) : status === "checking" ? (
          <>
            <div className="tick-label">Confirming with Stripe...</div>
            <h1 className="font-display font-black text-4xl tracking-tighter mt-3">One moment.</h1>
          </>
        ) : (
          <>
            <X size={64} className="text-neutral-500 mx-auto" />
            <h1 className="font-display font-black text-4xl tracking-tighter mt-4">Could not confirm.</h1>
            <p className="text-neutral-400 mt-3">Please refresh or check your bookings.</p>
            <Link to="/cook" className="btn-outline inline-block mt-6">Go to bookings</Link>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20 text-center">
        <X size={64} className="text-neutral-500 mx-auto" />
        <h1 data-testid="payment-cancel" className="font-display font-black text-5xl tracking-tighter mt-6">Checkout cancelled.</h1>
        <p className="text-neutral-400 mt-4">No charge was made. You can retry from your dashboard.</p>
        <Link to="/cook" className="btn-signal inline-block mt-8">Back to dashboard</Link>
      </div>
    </div>
  );
}
